import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';
import {ReadMoreModule} from '../read-more/read-more.module';
import {RouterModule} from '@angular/router';
import {CommentsComponent} from './comments.component';

@NgModule({
  declarations: [CommentsComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslatePipe,
    TranslateDirective,
    ReactiveFormsModule,
    ReadMoreModule,
    RouterModule,
  ],
  exports: [CommentsComponent]
})
export class CommentsModule {
}
